export default "__VITE_ASSET__BwgGlvVv__"